<template>
  <div class="chat-room">
    <div class="room-header">
      <button @click="$emit('back')" class="back-btn">←</button>
      <span>{{ activeRoom && activeRoom.name }}</span>
    </div>

    <div class="messages-container" ref="messagesContainer" @scroll.passive="onScroll">
      <template v-for="item in displayItems">
        <div
          v-if="item && item.__type === 'date'"
          :key="'d-' + item.key"
          class="day-separator"
        >
          <span>{{ item.label }}</span>
        </div>

        <chat-message
          v-else
          :key="item && item.id != null ? 'm-' + item.id : 'm-' + item._key"
          :message="item"
        />
      </template>
    </div>

    <chat-input :room-id="roomId" @send="onSend"/>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
import ChatMessage from './ChatMessage.vue'
import ChatInput from './ChatInput.vue'

export default {
  name: 'ChatRoom',
  components: { ChatMessage, ChatInput },
  props: ['roomId'],
  data: function () {
    return { isNearBottom: true }
  },
  computed: {
    ...mapGetters('chatPlugin', ['activeRoom', 'activeRoomMessages']),
    messages: function () {
      return this.activeRoomMessages
    },
    displayItems: function () {
      var list = Array.isArray(this.messages) ? this.messages : []

      var sorted = list.slice().sort(function (a, b) {
        var ta = a && a.timestamp ? new Date(a.timestamp).getTime() : 0
        var tb = b && b.timestamp ? new Date(b.timestamp).getTime() : 0
        return ta - tb
      })

      var out = []
      var lastKey = null

      for (var i = 0; i < sorted.length; i++) {
        var m0 = sorted[i]
        var d = this.getMessageDate(m0)
        var key = d ? this.dayKey(d) : 'sem-data'

        if (key !== lastKey) {
          out.push({ __type: 'date', key: key, label: this.formatDayLabel(d) })
          lastKey = key
        }

        var m = m0
        if (m0 && m0.id == null) m = Object.assign({ _key: key + '-' + i }, m0)

        out.push(m)
      }

      return out
    }
  },
  watch: {
    messages: function () {
      var self = this
      this.$nextTick(function () {
        var last = Array.isArray(self.messages) && self.messages.length
          ? self.messages[self.messages.length - 1]
          : null

        var userId = self.$store && self.$store.state && self.$store.state.auth && self.$store.state.auth.user
          ? self.$store.state.auth.user.id
          : null

        var isOwn = last && userId != null && String(last.senderId) === String(userId)

        if (self.isNearBottom || isOwn) self.scrollToBottom()
      })
    }
  },
  methods: {
    onSend: function (payload) {
      var content = payload
      var files = []

      if (payload && typeof payload === 'object') {
        content = payload.content || ''
        files = Array.isArray(payload.files) ? payload.files : []
      }

      this.$store.dispatch('chatPlugin/sendMessage', {
        roomId: this.roomId,
        content: content,
        files: files
      }).then(() => {
        this.scrollToBottom()
      })
    },

    scrollToBottom: function () {
      this.$nextTick(() => {
        var c = this.$refs.messagesContainer
        if (c) c.scrollTop = c.scrollHeight
      })
    },

    onScroll: function () {
      var c = this.$refs.messagesContainer
      if (!c) return
      var distanceFromBottom = c.scrollHeight - (c.scrollTop + c.clientHeight)
      this.isNearBottom = distanceFromBottom < 140
    },

    getMessageDate: function (message) {
      if (!message || !message.timestamp) return null
      var dt = new Date(message.timestamp)
      if (isNaN(dt.getTime())) return null
      return new Date(dt.getFullYear(), dt.getMonth(), dt.getDate())
    },

    dayKey: function (dateObj) {
      if (!dateObj) return 'sem-data'
      var y = dateObj.getFullYear()
      var m = String(dateObj.getMonth() + 1).padStart(2, '0')
      var d = String(dateObj.getDate()).padStart(2, '0')
      return y + '-' + m + '-' + d
    },

    formatDayLabel: function (dateObj) {
      if (!dateObj) return 'Sem data'
      var today = new Date()
      var d0 = new Date(today.getFullYear(), today.getMonth(), today.getDate())
      var diffDays = Math.round((d0.getTime() - dateObj.getTime()) / 86400000)
      if (diffDays === 0) return 'Hoje'
      if (diffDays === 1) return 'Ontem'
      return dateObj.toLocaleDateString('pt-BR', {
        weekday: 'short',
        day: '2-digit',
        month: '2-digit',
        year: 'numeric'
      })
    }
  },
  mounted: function () {
    this.scrollToBottom()
  }
}
</script>

<style scoped>
.chat-room { height: 100%; display: flex; flex-direction: column; }
.room-header { padding: 12px 16px; border-bottom: 1px solid #eee; display: flex; align-items: center; gap: 12px; background: #f9f9f9; }
.back-btn { background: none; border: none; font-size: 24px; cursor: pointer; padding: 0; }
.messages-container { flex: 1; overflow-y: auto; padding: 16px; }
.day-separator { display: flex; justify-content: center; margin: 10px 0 14px; }
.day-separator span { font-size: 12px; padding: 6px 10px; border-radius: 999px; background: #f2f2f2; color: #666; }
</style>



// WEBPACK FOOTER //
// ChatRoom.vue?ee5e5992